/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import deptBadge from "@/assets/Dept_Badge.png";
import go from "@/assets/go.svg";
import kababMenuSm from "@/assets/kabab-menu-sm.svg";
import leftNavExtit from "@/assets/leftNavExtit.svg";
import map from "@/assets/map.svg";
import notificationBell from "@/assets/notification_bell.svg";
import search from "@/assets/search.svg";
import arrowDownBlueSm from "@/assets/arrow-down-blue-sm.svg";
import Dropdown, { DROPDOWN_VARIANT } from "@/common/elements/Dropdown";
import CascaderMenu from "@/common/elements/CascaderMenu";
import {
  GoButton,
  HeaderContainer,
  MainHeader,
  NotificationButton,
  ReleaseQueueButton,
  SearchButton,
  SherifLogo,
  TaskButton,
  TasksNumber,
} from "./styles";
import { ROUTES_PATH } from "@/routes";
import { configMenuItems } from "@/demo-data";
import {
  setBookings,
  setBookingsFieldsEnabled,
  setBookingsNull,
  setLastBookingsFromAPI,
  setIsScheduledBooking,
  setShowBookings,
  setIrisDeviceConnected,
} from "@/slices/bookingsSlice";
import { MODULES_LIST } from "@/util/common_variable";
import api from "@/services/axios_custom";
import API_ENDPOINTS, { PHOTOS_BASE_URL_LOGO } from "@/util/api";
import useDialog from "@/hooks/useDialog";
import {
  setConfigModules,
  setConfigSubModules,
  setReports,
  setTablesViewsNew,
} from "@/slices/configSlice";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import Modal from "@/common/elements/Modal";
import notificationService from "@/util/notificationService";
import { getAllowedMenu } from "./getCachedAllowedMenu";
import SpinLoader from "@/common/elements/SpinLoader";
import { setFullSearch } from "@/slices/fullSearchSlice";

const transformGoOptions = (options, configModules, configSubModules) =>
  options.reduce((acc, option) => {
    const children = option.children
      ? transformGoOptions(option.children, configModules, configSubModules)
      : [];

    if (option.module) {
      const matchSub = configSubModules.find(
        (sm) =>
          sm.subModuleName?.toLowerCase() === option.label.toLowerCase() &&
          sm.enabled,
      );
      if (matchSub) {
        acc.push(option);
      }
    } else {
      const matchMod = configModules.find(
        (mod) =>
          mod.moduleName?.toLowerCase() === option.label.toLowerCase() &&
          mod.enabled,
      );
      if (matchMod) {
        acc.push({
          ...option,
          ...(children.length ? { children } : {}),
        });
      }
    }

    return acc;
  }, []);

const ActionButton = ({ as: Component, ...props }) => (
  <Component {...props} className="action-btn" />
);

// eslint-disable-next-line react/display-name
const Header = React.forwardRef(({ routes }, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { showDialog } = useDialog();

  const { configModules, allSubModules } = useSelector((state) => state.config);
  const { LastBookingsFromAPI, showBookings, bookingsFieldsEnabled } =
    useSelector((state) => state.bookings);
  const [localConfigModules, setLocalConfigModules] = useState(
    configModules || [],
  );
  const [localConfigSubModules, setLocalConfigSubModules] = useState([]);
  const [loadingConfigModules, setLoadingConfigModules] = useState(true);
  const [loadingConfigSubModules, setLoadingConfigSubModules] = useState(true);
  const [configPageSetting, setConfigPageSetting] = useState(false);
  const [logo, setLogo] = useState(null);
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [showModal, setShowModal] = useState(false);
  let nav = sessionStorage.getItem("initialModule");
  const [isIrisAppRunning, setIsIrisAppRunning] = useState(false);
  const wsRef = useRef(null);
  const [irisDC, setIrisDC] = useState(false);
  const { isLoading: userDetailLoading, userSecurityUpdated } = useSelector(
    (state) => state?.userDetail,
  );

  const whiteLoader = (
    <LoadingOutlined style={{ fontSize: 20, color: "#fff" }} spin />
  );

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments[0] === "config") {
      setConfigPageSetting(true);
    } else if (pathSegments[0] === "create-booking") {
      dispatch(setBookingsFieldsEnabled(true));
    } else if (pathSegments[0] == "staffing") {
      dispatch(setShowBookings(false));
    } else {
      setConfigPageSetting(false);
    }
  }, [location.pathname, dispatch]);

  // fetch modules
  useEffect(() => {
    const irisService = localStorage.getItem("iris_service_run");
    setLoadingConfigModules(true);
    countyLogo();
    api
      .get(API_ENDPOINTS.config.configModule.getAllConfigModule)
      .then((res) => {
        setLocalConfigModules(res.data);
        dispatch(setConfigModules(res?.data));
      })
      .catch((err) => console.error("Error fetching config modules:", err))
      .finally(() => setLoadingConfigModules(false));
    api
      .get(API_ENDPOINTS.config.reports.getAll)
      .then((res) => {
        dispatch(setReports(res?.data));
      })
      .catch((err) => console.error("Error fetching config Reports:", err))
      .finally(() => setLoadingConfigModules(false));
    api
      .get(API_ENDPOINTS.config.tableViews.getAll)
      .then((res) => {
        dispatch(setTablesViewsNew(res?.data));
      })
      .catch((err) => console.error("Error fetching config Table view:", err))
      .finally(() => setLoadingConfigModules(false));
  }, []);

  useEffect(() => {
    setLoadingConfigSubModules(true);
    api
      .get(API_ENDPOINTS.config.configModule.getAllConfigSubModules)
      .then((res) => {
        setLocalConfigSubModules(res.data);
        dispatch(setConfigSubModules(res?.data));
      })
      .catch((err) => console.error("Error fetching config sub-modules:", err))
      .finally(() => setLoadingConfigSubModules(false));
  }, []);

  // useEffect(() => {
  //   let ws = null;
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       ws = new WebSocket("ws://localhost:8080/ws/device");
  //       console.log("Page is visible again!", ws);
  //       wsRef.current = ws;
  //       ws.onopen = () => {
  //         setIsIrisAppRunning(true);
  //         // localStorage.setItem("iris_service_run", "true");
  //         // notificationService.success("Iris App", "Iris service connected");
  //       };

  //       ws.onmessage = (msg) => {
  //         const data = JSON.parse(msg.data);
  //         if (data?.connected) {
  //           console.log("connected");
  //           notificationService.success("Iris App", "Iris device connected");
  //         } else {
  //           notificationService.error("Iris App", "Iris device disconnected");
  //         }
  //         dispatch(setIrisDeviceConnected(data.connected));
  //       };

  //       ws.onclose = () => {
  //         dispatch(setIrisDeviceConnected(false));
  //         // localStorage.setItem("iris_service_run", "false");
  //         setIsIrisAppRunning(false);
  //       };

  //       ws.onerror = (err) => {
  //         console.error("WebSocket Error:", err);
  //         // dispatch(setIrisDeviceConnected(false));
  //         // notificationService.error("Iris App", "Service connection closed");
  //         // setIsIrisAppRunning(false);
  //       };
  //     } else {
  //       console.log("Page is hidden!");
  //       dispatch(setIrisDeviceConnected(false));
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //     ws.close();
  //   };
  // }, []);

  useEffect(() => {
    if (configModules?.length) setLocalConfigModules(configModules);
  }, [configModules]);

  useEffect(() => {
    if (allSubModules?.length) setLocalConfigSubModules(allSubModules);
  }, [allSubModules]);

  const loginUserName =
    JSON.parse(localStorage.getItem("userDetails"))?.username || "";

  const countyLogo = () => {
    api
      .get(API_ENDPOINTS.countyLogo)
      .then((response) => {
        const paramValue = response.data[0]?.paramValue;
        if (paramValue) {
          setLogo(PHOTOS_BASE_URL_LOGO + paramValue);
          setLoadingLogo(true);
        }
      })
      .catch((err) => {
        console.error("Error fetching logo:", err);
        setLoadingLogo(false);
      })
      .finally(() => {
        // setLoadingLogo(true);
      });
  };

  const goOptionsPre = [
    { key: "audit-log", label: "Audit Log" },
    { key: "config", label: "Config" },
    { key: "dashboard", label: "Dashboard" },
    { key: "charge-maintenance", label: "Charge Maintenance" },
    {
      key: "bookings",
      label: "Bookings",
    },
    { key: "booking-queue", label: "Booking Queue" },
    { key: "facility-log", label: "Facility Log" },
    { key: "release-queue", label: "Release Queue" },
    { key: "create-booking", label: "Create Booking" },
    { key: "inmate-movement", label: "Inmate Movement" },
    { key: "inmate-watch", label: "Inmate Watch" },
    { key: "batch-inmate-movement", label: "Batch Inmate Movement" },
    { key: "charges", label: "Charges" },
    { key: "citations", label: "Citations" },
    { key: "detentions", label: "Detentions" },
    { key: "jail-incidents", label: "Jail Incidents" },
    { key: "visitor-log", label: "Visitor Log" },
    { key: "security", label: "Security" },
    { key: "staffing", label: "Staff" },
    { key: "users", label: "Users" },
    { key: "warrants", label: "Warrants" },
    { key: "civil-papers", label: "Civil Papers" },
    { key: "intake-queue", label: "Intake Queue" },
  ];

  const goOptions = goOptionsPre.sort((a, b) => a.key.localeCompare(b.key));
  const configMenuOptions = configMenuItems;
  const handleGoSelect = async (selected) => {
    if (selected?.key == "bookings" && !bookingsFieldsEnabled) {
      dispatch(setShowBookings(false));
    }
    if (selected?.key == "staffing" && !bookingsFieldsEnabled) {
      dispatch(setShowBookings(false));
    }
    // if (
    //   window.location.pathname?.includes("bookings") &&
    //   showBookings &&
    //   bookingsFieldsEnabled
    // ) {
    //   const content = `You are modifying the Bookings page. Do you wish to proceed to another page?`;
    //   const canNavigate = await new Promise((resolve, reject) => {
    //     showDialog("confirm", {
    //       title: "Warning",
    //       content: content,
    //       onConfirm: () => {
    //         resolve(true);
    //         if (selected?.key == "bookings") {
    //           dispatch(setShowBookings(false));
    //         }
    //       },
    //       onCancel: () => {
    //         resolve(false);
    //       },
    //     });
    //   });
    //   if (!canNavigate) {
    //     return;
    //   }
    //   dispatch(setShowBookings(false));
    // }

    if (
      (window.location.pathname?.includes("bookings") ||
        window.location.pathname?.includes("staff")) &&
      showBookings &&
      bookingsFieldsEnabled
    ) {
      const content = `You are modifying the ${
        window.location.pathname?.includes("staff") ? "staff" : "Bookings"
      } page. Do you wish to proceed to another page?`;
      const canNavigate = await new Promise((resolve, reject) => {
        showDialog("confirm", {
          title: "Warning",
          content: content,
          onConfirm: () => {
            resolve(true);
            if (selected?.key == "bookings" || selected?.key == "staffing") {
              dispatch(setShowBookings(false));
              dispatch(setFullSearch(false));
            }
          },
          onCancel: () => {
            resolve(false);
          },
        });
      });
      if (!canNavigate) {
        return;
      }
      dispatch(setShowBookings(false));
    }

    if (
      window.location.pathname?.includes(selected?.key?.split("-")[0]) &&
      !selected?.key?.split("-")[1]
    ) {
      return;
    }

    dispatch(setBookings(LastBookingsFromAPI));
    dispatch(setBookingsFieldsEnabled(false));
    if (selected?.key === "config") {
      setConfigPageSetting(true);
      navigate(`/${selected?.key}`);
    } else if (selected?.key?.split("_")[0] == "bookings") {
      sessionStorage.setItem("from-jacket", false);
      dispatch(setIsScheduledBooking(false));
      dispatch(setFullSearch(false));
      navigate("/bookings", {
        state: { module: selected?.key?.split("_")[1] },
      });
    } else if (selected?.key === "create-booking") {
      sessionStorage.setItem("from-jacket", false);
      sessionStorage.setItem("jacket-before", MODULES_LIST.BOOKING_INTAKE);
      dispatch(setIsScheduledBooking(false));
      dispatch(setBookingsNull());
      dispatch(setBookingsFieldsEnabled(true));
      navigate("/folder-search");
    } else {
      navigate(`/${selected?.key}`);
    }
  };

  const handleConfigSelect = (selected) => {};

  const finalGoOptions = useMemo(() => {
    // show everything until modules have loaded
    if (loadingConfigModules || loadingConfigSubModules) return goOptions;
    return transformGoOptions(
      goOptions,
      localConfigModules,
      localConfigSubModules,
    );
  }, [
    loadingConfigModules,
    localConfigModules,
    localConfigSubModules,
    loadingConfigSubModules,
    goOptions,
  ]);

  const finalGoOptionsMenu = getAllowedMenu(finalGoOptions);

  useEffect(() => {
    if (configModules?.length) setLocalConfigModules(configModules);
  }, [configModules]);

  // const logoutSession = () => {
  //   localStorage.removeItem("authToken");
  //   localStorage.removeItem("refreshToken");
  //   localStorage.removeItem("userDetails");
  //   window.location.reload();
  // };
  const logoutSession = async () => {
    try {
      const response = await api.get(API_ENDPOINTS.logout);
      console.log("Logout success:", response.data);

      localStorage.removeItem("allowedMenu");
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userDetails");
      window.location.reload();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  useEffect(() => {
    let loc = window.location.pathname;
    setTimeout(() => {
      if (isNonEmptyVariable(nav)) {
        let hasAccess = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.module,
          LABELS_CAPITAL.VIEW,
          nav,
        );
        if (isNonEmptyVariable(hasAccess)) {
          if (!hasAccess) {
            if (loc.includes(nav)) setShowModal(true);
          }
        }
      }
    }, 1500);
  }, []);
  return (
    <>
      <MainHeader ref={ref}>
        <HeaderContainer>
          {/* <ActionButton as={SearchButton} variant="dark" onClick={() => navigate(ROUTES_PATH.JACKET_SEARCH)}>
        <img alt="Search Icon" src={search} />
      </ActionButton> */}
          {configPageSetting ? (
            <>
              <ActionButton
                as={SearchButton}
                onClick={() => {
                  dispatch(setBookingsNull());
                  dispatch(setBookingsFieldsEnabled(true));
                  navigate(ROUTES_PATH.CREATE_BOOKING);
                }}
              >
                <img src={leftNavExtit} width="50" alt="Back" />
              </ActionButton>
              <ActionButton as={SearchButton}>
                <img src={map} width="35" alt="Map" />
              </ActionButton>
            </>
          ) : (
            <ActionButton
              as={SearchButton}
              onClick={() => {
                dispatch(setBookingsNull());
                dispatch(setBookingsFieldsEnabled(true));
                sessionStorage.setItem("isScheduledBooking", false);
                sessionStorage.setItem(
                  "jacket-before",
                  MODULES_LIST.BOOKING_INTAKE,
                );
                navigate(ROUTES_PATH.JACKET_SEARCH);
              }}
            >
              <img alt="Search Icon" src={search} />
            </ActionButton>
          )}
          <div className="center">
            <div className="main">
              <>
                <CascaderMenu
                  placeholder="GO"
                  togglerIcon={
                    !userSecurityUpdated ? (
                      <SpinLoader
                        className="custom-spin-bg-white"
                        size="middle"
                      />
                    ) : (
                      <img className="arrow-img" src={arrowDownBlueSm} />
                    )
                  }
                  items={userSecurityUpdated ? finalGoOptionsMenu : []}
                  disabled={!userSecurityUpdated}
                  showSelectedLabel={false}
                  onSelect={handleGoSelect}
                />
                {configPageSetting && (
                  <div style={{ marginLeft: "15px" }}>
                    <CascaderMenu
                      placeholder="CONFIG"
                      placement="topLeft"
                      items={configMenuOptions}
                      onSelect={handleConfigSelect}
                      showSelectedLabel={false}
                      togglerIcon={
                        <img alt="CONFIG Icon" src={kababMenuSm} width="100%" />
                      }
                    />
                  </div>
                )}
                {/* <ActionButton as={GoButton} variant="dark" style={{minWidth:"110px",fontSize:"20px"}}>
            CONFIG&nbsp;
            <img alt="CONFIG Icon" src={kababMenuSm} width="24" />
            </ActionButton> */}
              </>

              {/* <Breadcrumb routes={routes} /> */}
              {/* <div className="breadcrumb-container">
            <ol className="breadcrumb">
            <li className="breadcrumb-item prev">Booking</li>
            <li className="breadcrumb-item active">Booking Queue</li>
            </ol>
            </div> */}
              {/* <div className="form-check form-switch">
            <input className="form-check-input" id="flexSwitchCheckDefault" role="switch" type="checkbox" />
            </div> */}
              {/* <button className="release-queue-btn no-btn-btn">Release Queue</button> */}
              <ReleaseQueueButton
                color="primary"
                type="link"
                variant="link"
              ></ReleaseQueueButton>
            </div>
            {/* <div className="tasks-right">
            <Dropdown
              label={'J. Patterson 5127'}
              variant={DROPDOWN_VARIANT.TEXT_BLUE}
              >
              <Dropdown.Item>Action</Dropdown.Item>
              <Dropdown.Item>Another action</Dropdown.Item>
              <Dropdown.Item>Something Else</Dropdown.Item>
              </Dropdown>
              <TasksNumber>
              <span className="green">27</span>
              <span className="red">32</span>
              </TasksNumber>
              <ActionButton as={TaskButton} color="primary" type="primary" variant="solid">
              <img alt="Tasks Icon" src={tasks} />
              </ActionButton>
              </div> */}
          </div>

          <div className="right">
            <ActionButton
              as={NotificationButton}
              color="primary"
              type="primary"
              variant="solid"
            >
              <img alt="Notification Bell" src={notificationBell} />
            </ActionButton>
            <Dropdown
              label={
                <SherifLogo
                  className="sheriff-logo"
                  src={loadingLogo ? logo : deptBadge}
                  alt="County Logo"
                />
              }
              variant={DROPDOWN_VARIANT.TEXT_BLUE}
            >
              <Dropdown.Item onClick={logoutSession}>
                Logout {loginUserName}
              </Dropdown.Item>
            </Dropdown>
          </div>
        </HeaderContainer>
      </MainHeader>
      {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          footerActions={[
            {
              key: "OK",
              text: "OK",
              onClick: () => {
                navigate();
                setShowModal(false);
                navigate(ROUTES_PATH.DASHBOARD);
              },
            },
          ]}
        >
          You are not having access to the {nav} module. want to re route to
          default module?
        </Modal>
      )}
    </>
  );
});

export default Header;
